import {IsoLan} from "./IOrderDetail";

export function convertIsoLan(value: IsoLan) {
	switch (value) {
		case IsoLan.VAD:
			return "Andorra";
		case IsoLan.VAE:
			return "Verenigde Arabische Emiraten";
		case IsoLan.VAF:
			return "Afghanistan";
		case IsoLan.VAG:
			return "Antigua en Barbuda";
		case IsoLan.VAI:
			return "Anguilla";
		case IsoLan.VAL:
			return "Albanië";
		case IsoLan.VAM:
			return "Armenië";
		case IsoLan.VAN:
			return "Nederlandse Antillen";
		case IsoLan.VAO:
			return "Angola";
		case IsoLan.VAQ:
			return "Antartica";
		case IsoLan.VAR:
			return "Argentinië";
		case IsoLan.VAS:
			return "Amerikaans Samoa";
		case IsoLan.VAT:
			return "Oostenrijk";
		case IsoLan.VAU:
			return "Australië";
		case IsoLan.VAW:
			return "Aruba";
		case IsoLan.VAX:
			return "Aaland eilanden";
		case IsoLan.VAZ:
			return "Azerbeidzjan";
		case IsoLan.VBA:
			return "Bosnië Herzegovina";
		case IsoLan.VBB:
			return "Barbados";
		case IsoLan.VBD:
			return "Bangladesh";
		case IsoLan.VBE:
			return "België";
		case IsoLan.VBF:
			return "Burkina Faso";
		case IsoLan.VBG:
			return "Bulgarije";
		case IsoLan.VBH:
			return "Bahrein";
		case IsoLan.VBI:
			return "Burundi";
		case IsoLan.VBJ:
			return "Benin";
		case IsoLan.VBL:
			return "Sint Bartholomeus";
		case IsoLan.VBM:
			return "Bermuda";
		case IsoLan.VBN:
			return "Brunei Darussalam";
		case IsoLan.VBO:
			return "Bolivia";
		case IsoLan.VBQ:
			return "Bonaire, Sint Eustatius en Saba";
		case IsoLan.VBR:
			return "Brazilië";
		case IsoLan.VBS:
			return "Bahamas";
		case IsoLan.VBT:
			return "Bhutan";
		case IsoLan.VBV:
			return "Bouvet Island";
		case IsoLan.VBW:
			return "Botswana";
		case IsoLan.VBY:
			return "Wit-Rusland";
		case IsoLan.VBZ:
			return "Belize";
		case IsoLan.VCA:
			return "Canada";
		case IsoLan.VCC:
			return "Cocos Eilanden";
		case IsoLan.VCD:
			return "Democratische Republiek Congo";
		case IsoLan.VCF:
			return "Centraal Afrikaanse Republiek";
		case IsoLan.VCG:
			return "Republiek Congo";
		case IsoLan.VCH:
			return "Zwitserland";
		case IsoLan.VCI:
			return "Ivoorkust";
		case IsoLan.VCK:
			return "Cook Eilanden";
		case IsoLan.VCL:
			return "Chili";
		case IsoLan.VCM:
			return "Kameroen";
		case IsoLan.VCN:
			return "China";
		case IsoLan.VCO:
			return "Colombia";
		case IsoLan.VCR:
			return "Costa Rica";
		case IsoLan.VCS:
			return "Servië en Montenegro";
		case IsoLan.VCU:
			return "Cuba";
		case IsoLan.VCV:
			return "Kaap Verdische Eilanden";
		case IsoLan.VCW:
			return "Curaçao";
		case IsoLan.VCX:
			return "Christmas Island";
		case IsoLan.VCY:
			return "Cyprus";
		case IsoLan.VCZ:
			return "Tsjechië";
		case IsoLan.VDE:
			return "Duitsland";
		case IsoLan.VDJ:
			return "Djibouti";
		case IsoLan.VDK:
			return "Denemarken";
		case IsoLan.VDM:
			return "Dominica";
		case IsoLan.VDO:
			return "Dominicaanse Republiek";
		case IsoLan.VDZ:
			return "Algerije";
		case IsoLan.VEC:
			return "Ecuador";
		case IsoLan.VEE:
			return "Estland";
		case IsoLan.VEG:
			return "Egypte";
		case IsoLan.VEH:
			return "Westelijke Sahara";
		case IsoLan.VER:
			return "Eritrea";
		case IsoLan.VES:
			return "Spanje";
		case IsoLan.VET:
			return "Ethiopië";
		case IsoLan.VFI:
			return "Finland";
		case IsoLan.VFJ:
			return "Fiji";
		case IsoLan.VFK:
			return "Falkland Eilanden";
		case IsoLan.VFM:
			return "Micronesië";
		case IsoLan.VFO:
			return "Faroer Eilanden";
		case IsoLan.VFR:
			return "Frankrijk";
		case IsoLan.VGA:
			return "Gabon";
		case IsoLan.VGB:
			return "Verenigd Koninkrijk";
		case IsoLan.VGD:
			return "Grenada";
		case IsoLan.VGE:
			return "Georgië";
		case IsoLan.VGF:
			return "Frans Guyana";
		case IsoLan.VGG:
			return "Guernsey";
		case IsoLan.VGH:
			return "Ghana";
		case IsoLan.VGI:
			return "Gibraltar";
		case IsoLan.VGL:
			return "Groenland";
		case IsoLan.VGM:
			return "Gambia";
		case IsoLan.VGN:
			return "Guinea";
		case IsoLan.VGP:
			return "Guadeloupe";
		case IsoLan.VGQ:
			return "Equatorial Guinea";
		case IsoLan.VGR:
			return "Griekenland";
		case IsoLan.VGS:
			return "Sandwich Eilanden";
		case IsoLan.VGT:
			return "Guatemala";
		case IsoLan.VGU:
			return "Guam";
		case IsoLan.VGW:
			return "Guinea-Bissau";
		case IsoLan.VGY:
			return "Guyana";
		case IsoLan.VHK:
			return "Hongkong";
		case IsoLan.VHM:
			return "Heard Eiland en McDonald Eilanden";
		case IsoLan.VHN:
			return "Honduras";
		case IsoLan.VHR:
			return "Kroatië";
		case IsoLan.VHT:
			return "Haiti";
		case IsoLan.VHU:
			return "Hongarije";
		case IsoLan.VID:
			return "Indonesië";
		case IsoLan.VIE:
			return "Ierland";
		case IsoLan.VIL:
			return "Israël";
		case IsoLan.VIM:
			return "Isle of Man";
		case IsoLan.VIN:
			return "India";
		case IsoLan.VIO:
			return "British Indian Ocean Territory";
		case IsoLan.VIQ:
			return "Irak";
		case IsoLan.VIR:
			return "Iran";
		case IsoLan.VIS:
			return "IJsland";
		case IsoLan.VIT:
			return "Italië";
		case IsoLan.VJE:
			return "Jersey";
		case IsoLan.VJM:
			return "Jamaica";
		case IsoLan.VJO:
			return "Jordanië";
		case IsoLan.VJP:
			return "Japan";
		case IsoLan.VKE:
			return "Kenia";
		case IsoLan.VKG:
			return "Kirgizië";
		case IsoLan.VKH:
			return "Cambodja";
		case IsoLan.VKI:
			return "Kiribati";
		case IsoLan.VKM:
			return "Comores";
		case IsoLan.VKN:
			return "St Kitts en Nevis";
		case IsoLan.VKP:
			return "Noord Korea";
		case IsoLan.VKR:
			return "Zuid Korea";
		case IsoLan.VKW:
			return "Koeweit";
		case IsoLan.VKY:
			return "Kaaiman Eilanden";
		case IsoLan.VKZ:
			return "Kazachstan";
		case IsoLan.VLA:
			return "Laos";
		case IsoLan.VLB:
			return "Libanon";
		case IsoLan.VLC:
			return "Santa Lucia";
		case IsoLan.VLI:
			return "Liechtenstein";
		case IsoLan.VLK:
			return "Sri Lanka";
		case IsoLan.VLR:
			return "Liberia";
		case IsoLan.VLS:
			return "Lesotho";
		case IsoLan.VLT:
			return "Litouwen";
		case IsoLan.VLU:
			return "Luxemburg";
		case IsoLan.VLV:
			return "Letland";
		case IsoLan.VLY:
			return "Libië";
		case IsoLan.VMA:
			return "Marokko";
		case IsoLan.VMC:
			return "Monaco";
		case IsoLan.VMD:
			return "Republiek Moldavië";
		case IsoLan.VME:
			return "Montenegro";
		case IsoLan.VMF:
			return "Sint Maarten (Frans)";
		case IsoLan.VMG:
			return "Madagascar";
		case IsoLan.VMH:
			return "Marshall Eilanden";
		case IsoLan.VMK:
			return "Macedonië";
		case IsoLan.VML:
			return "Mali";
		case IsoLan.VMM:
			return "Myanmar";
		case IsoLan.VMN:
			return "Mongolië";
		case IsoLan.VMO:
			return "Macau";
		case IsoLan.VMP:
			return "Noordelijke Mariana Eilanden";
		case IsoLan.VMQ:
			return "Martinique";
		case IsoLan.VMR:
			return "Mauretanië";
		case IsoLan.VMS:
			return "Montserrat";
		case IsoLan.VMT:
			return "Malta";
		case IsoLan.VMU:
			return "Mauritius";
		case IsoLan.VMV:
			return "Malediven";
		case IsoLan.VMW:
			return "Malawi";
		case IsoLan.VMX:
			return "Mexico";
		case IsoLan.VMY:
			return "Maleisië";
		case IsoLan.VMZ:
			return "Mozambique";
		case IsoLan.VNA:
			return "Namibië";
		case IsoLan.VNC:
			return "Nieuw Caledonië";
		case IsoLan.VNE:
			return "Republiek Niger";
		case IsoLan.VNF:
			return "Norfolk Eiland";
		case IsoLan.VNG:
			return "Nigeria";
		case IsoLan.VNI:
			return "Nicaragua";
		case IsoLan.VNL:
			return "Nederland";
		case IsoLan.VNO:
			return "Noorwegen";
		case IsoLan.VNP:
			return "Nepal";
		case IsoLan.VNR:
			return "Nauru";
		case IsoLan.VNU:
			return "Niue";
		case IsoLan.VNZ:
			return "Nieuw Zeeland";
		case IsoLan.VOM:
			return "Oman";
		case IsoLan.VPA:
			return "Panama";
		case IsoLan.VPE:
			return "Peru";
		case IsoLan.VPF:
			return "Frans Polynesië";
		case IsoLan.VPG:
			return "Papua Nieuw Guinea";
		case IsoLan.VPH:
			return "Filipijnen";
		case IsoLan.VPK:
			return "Pakistan";
		case IsoLan.VPL:
			return "Polen";
		case IsoLan.VPM:
			return "St Pierre en Miquelon";
		case IsoLan.VPN:
			return "Pitcairn";
		case IsoLan.VPR:
			return "Porto Rico";
		case IsoLan.VPS:
			return "Palestina";
		case IsoLan.VPT:
			return "Portugal";
		case IsoLan.VPW:
			return "Palau";
		case IsoLan.VPY:
			return "Paraguay";
		case IsoLan.VQA:
			return "Quatar";
		case IsoLan.VRE:
			return "Reunion";
		case IsoLan.VRO:
			return "Roemenië";
		case IsoLan.VRS:
			return "Servië";
		case IsoLan.VRU:
			return "Rusland";
		case IsoLan.VRW:
			return "Rwanda";
		case IsoLan.VSA:
			return "Saoedi-Arabië";
		case IsoLan.VSB:
			return "Solomon Eilanden";
		case IsoLan.VSC:
			return "Seychellen";
		case IsoLan.VSD:
			return "Soedan";
		case IsoLan.VSE:
			return "Zweden";
		case IsoLan.VSG:
			return "Singapore";
		case IsoLan.VSH:
			return "St Helena";
		case IsoLan.VSI:
			return "Slovenië";
		case IsoLan.VSJ:
			return "Svalbard en Jan Mayen";
		case IsoLan.VSK:
			return "Slowakije";
		case IsoLan.VSL:
			return "Sierra Leone";
		case IsoLan.VSM:
			return "San Marino";
		case IsoLan.VSN:
			return "Senegal";
		case IsoLan.VSO:
			return "Somalië";
		case IsoLan.VSR:
			return "Suriname";
		case IsoLan.VSS:
			return "Zuid-Soedan";
		case IsoLan.VST:
			return "Sao Tome en Principe";
		case IsoLan.VSV:
			return "El Salvador";
		case IsoLan.VSX:
			return "Sint Maarten (Dutch part)";
		case IsoLan.VSY:
			return "Syrië";
		case IsoLan.VSZ:
			return "Swaziland";
		case IsoLan.VTC:
			return "Turks en Caicos Eilanden";
		case IsoLan.VTD:
			return "Tsjaad";
		case IsoLan.VTF:
			return "Franse Zuidelijke Territories";
		case IsoLan.VTG:
			return "Togo";
		case IsoLan.VTH:
			return "Thailand";
		case IsoLan.VTJ:
			return "Tadzjikistan";
		case IsoLan.VTK:
			return "Tokelau";
		case IsoLan.VTL:
			return "Timor Leste";
		case IsoLan.VTM:
			return "Turkmenistan";
		case IsoLan.VTN:
			return "Tunesië";
		case IsoLan.VTO:
			return "Tonga";
		case IsoLan.VTR:
			return "Turkije";
		case IsoLan.VTT:
			return "Trinidad en Tobago";
		case IsoLan.VTV:
			return "Tuvalu";
		case IsoLan.VTW:
			return "Taiwan";
		case IsoLan.VTZ:
			return "Tanzania";
		case IsoLan.VUA:
			return "Oekraïne";
		case IsoLan.VUG:
			return "Uganda";
		case IsoLan.VUM:
			return "United States Minor Outlaying Eilanden";
		case IsoLan.VUS:
			return "Verenigde Staten";
		case IsoLan.VUY:
			return "Uruguay";
		case IsoLan.VUZ:
			return "Oezbekistan";
		case IsoLan.VVA:
			return "Vaticaanstad";
		case IsoLan.VVC:
			return "St Vincent en Grenada";
		case IsoLan.VVE:
			return "Venezuela";
		case IsoLan.VVG:
			return "Britse Maagdeneilanden";
		case IsoLan.VVI:
			return "Amerikaanse Maagdeneilanden";
		case IsoLan.VVN:
			return "Vietnam";
		case IsoLan.VVU:
			return "Vanuata";
		case IsoLan.VWF:
			return "Wallis en Futuna";
		case IsoLan.VWS:
			return "Samoa";
		case IsoLan.VYE:
			return "Yemen";
		case IsoLan.VYT:
			return "Mayotte";
		case IsoLan.VZA:
			return "Zuid Afrika";
		case IsoLan.VZM:
			return "Zambia";
		case IsoLan.VZW:
			return "Zimbabwe";
		case IsoLan.VZZ:
			return "Anders";
		default :
			return "";
	}
	return "";
}
